import { defineRecipe } from '@chakra-ui/react';

export function baseButtonRecipe() {
  return defineRecipe({
    variants: {
      auctioneerButton: {
        lotControl: {
          width: {
            base: '100%',
            full: '100%'
          },
          m: 0,
          p: 0
        },
        soldControl: {
          width: '32%'
        },
        increment: {
          p: '6px',
          m: 0,
          minH: '35px',
          h: 'fit-content',
          w: '70px',
          backgroundColor: 'green'
        },
        activeIncrement: {
          p: '6px',
          m: 0,
          minH: '35px',
          h: 'fit-content',
          w: '70px',
          backgroundColor: 'secondary.500'
        }
      }
    }
  });
}
